/* BEGIN CODEX GLOBAL COUNTDOWN INITIALIZER */
(() => {
  const storageKey = "codex-pdp-ae5dri-0r:global-countdown-target";
  const storedTarget = Number(sessionStorage.getItem(storageKey));
  if (!Number.isFinite(storedTarget) || storedTarget <= 0) {
    sessionStorage.setItem(storageKey, String(Date.now() + 3600000));
  }
})();
/* END CODEX GLOBAL COUNTDOWN INITIALIZER */
